import service = require("./breeze.entityManager.service");
import base = require("./base.dataservice");

export function initialize(module: ng.IModule) {
    module.service("CompetenceTypeCVMappingCompetenceTypeService", CompetenceTypeCVMappingCompetenceTypeService);

    CompetenceTypeCVMappingCompetenceTypeService.$inject = ["entityManagerService", "breeze", "$log", "$q"];
}

class CompetenceTypeCVMappingCompetenceTypeService extends base.BaseDataService<Nema.Crew.Model.CompetenceTypeCVMappingCompetenceType> implements ICompetenceTypeCVMappingCompetenceTypeService {

    constructor(entityManagerService: service.EntityManagerService, breeze, $log, $q: ng.IQService) {
        super(entityManagerService, breeze, $log, $q);
    }

    protected get EntityName(): string {
        return "CompetenceTypeCVMappingCompetenceType";
    }

    protected get EntitiesName(): string {
        return "CompetenceTypeCVMappingCompetenceTypes";
    }

    /**
     * Override the getAll, since CompetenceRequirementCollection do not 
     * have the Active and SortTag properties.
     */
    public getByCompetenceTypeMappingId(competenceTypeMappingId: number, _active: boolean = true) {

        var self = this;

        var entityQuery = self.createEntityQuery()
            .where("CompetenceTypeCVMappingId", "==", competenceTypeMappingId)
            .using(this.entityManager);

        var promise = entityQuery.execute()
        // ignore remote query results and chain to local query. Discarded the query results ... but items remain in cache
            .then(() => {
            self.entityCollection = entityQuery.using(self.breeze.FetchStrategy.FromLocalCache).executeLocally();
            return self.entityCollection;
        });

        return promise;
    }
}

export interface ICompetenceTypeCVMappingCompetenceTypeService extends base.IDataService<Nema.Crew.Model.CompetenceTypeCVMappingCompetenceType> {
    getByCompetenceTypeMappingId(competenceTypeMappingId: number, active?: boolean);
} 


// WEBPACK FOOTER //
// ./node_modules/angular2-template-loader!./node_modules/@angularclass/hmr-loader!./node_modules/tslint-loader!./client/app/core/CompetenceTypeCVMappingCompetenceType.dataservice.ts